import script from "./SoesahGamingApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./SoesahGamingApp.vue?vue&type=script&lang=ts&setup=true"

import "@/css/less/sg.less?vue&type=style&index=0&lang=less"

const __exports__ = script;

export default __exports__